import { Database, Search, Sparkles } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { ConnectionLines, IllustrationFrame } from './shared'

function SearchAnswer() {
  const { t } = useTranslation()
  const key = 'whatsNew.slides.structuredSearch.graphic'
  return (
    <g>
      <rect
        x="349"
        y="109"
        width="280"
        height="159"
        rx="14"
        className="fill-card stroke-primary/40"
      />
      <Sparkles x="367" y="126" width="18" height="18" className="text-primary-strong" />
      <text x="396" y="140" className="fill-foreground text-xs font-semibold">
        {t(`${key}.answer`)}
      </text>
      <path
        d="M367 161H604 M367 173H551"
        className="stroke-muted-foreground/20"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <rect x="367" y="190" width="244" height="28" rx="5" className="fill-primary/10" />
      <path
        d="M381 204H450 M478 204H519 M553 204H596 M381 233H438 M478 233H512 M553 233H596"
        className="stroke-primary/40"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <text
        x="489"
        y="287"
        textAnchor="middle"
        className="fill-primary-strong text-3xs font-medium"
      >
        {t(`${key}.sources`)}
      </text>
    </g>
  )
}

export function StructuredSearchIllustration() {
  const { t } = useTranslation()
  const key = 'whatsNew.slides.structuredSearch.graphic'
  return (
    <IllustrationFrame label={t(`${key}.description`)}>
      <ConnectionLines d="M212 193H275Q297 193 297 171V138Q297 126 309 126H349 M341 85V109" />
      <rect x="88" y="29" width="506" height="56" rx="16" className="fill-card stroke-primary/40" />
      <Search x="106" y="47" width="20" height="20" className="text-primary-strong" />
      <text x="140" y="62" className="fill-foreground text-xs font-medium">
        {t(`${key}.question`)}
      </text>
      <rect x="56" y="129" width="156" height="128" rx="14" className="fill-card stroke-border" />
      <Database x="74" y="147" width="25" height="25" className="text-primary-strong" />
      <text x="74" y="196" className="fill-foreground text-2xs font-semibold">
        {t(`${key}.rows`)}
      </text>
      <path
        d="M74 215H194 M74 229H172"
        className="stroke-muted-foreground/20"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <circle cx="297" cy="171" r="4" className="fill-primary" />
      <SearchAnswer />
    </IllustrationFrame>
  )
}
